export const FieldPatterns = {
  STANDARD_ALPHA_FIELD: /^[a-zA-Z\u00C0-\u017F.,#-]+(?:\s[a-zA-Z\u00C0-\u017F.,#-]+)*\s?$/, // Field  accepts lowercase, uppercase letters and special characters  (.) period, (,) comma, (-) hyphen, (#) pound or hash, french character accents e.g. è or î.
  BANK_FIELD_STANDARDS: /^[0-9A-ZÀ-ÖØ-Þa-zà-öø-þ#\-$.&*,\s]*$/, // alphanumeric spaces, (lower & upper), french & (# - , . & $ *)
  BANK_FIELD_REPLACE: /[^a-zA-Z0-9#$&*.,èéêëîïôöûüùç\s\u00C0-\u017F-]/g,
  STANDARD_KEYBOARD_CHARACHTERS:
    /[^A-Za-zÁÀÂÄÇÉÈÊËÍÌÎÏÓÒÔÖÚÙÛÜáàâäçéèêëíìîïóòôöúùûü0-9";%;!()*#+/><$&@=?:'~|`^_\[\]{}\\.,\s-]/g,
};
